(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookFolderDetailController', HandbookFolderDetailController);

    HandbookFolderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookFolder', 'Handbook', 'CustomUser'];

    function HandbookFolderDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookFolder, Handbook, CustomUser) {
        var vm = this;

        vm.handbookFolder = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookFolderUpdate', function(event, result) {
            vm.handbookFolder = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
